import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { forEach } from "lodash-es";
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import UcWindow from "../../../lib/UcWindow";
import { delay } from "../../../lib/utils";
import { elt, startMouseMove } from "../../../lib/utils/browser";
import Portal from '../Portal/Portal';
import "./PopupEditor.css";
let ICMBPopupEditor = class ICMBPopupEditor extends Vue {
  constructor() {
    super(...arguments);
    this.inited = false;
    this.left = '100px';
    this.top = '200px';
    this.width = 600;
    this.height = 400;
    this.escConfirming = null;
  }
  get modalVisible() {
    return this.owner.icmbPopupShown;
  }
  set modalVisible(val) {
    this.owner.icmbPopupShown = !!val;
  }
  toggleModal() {
    if (this.modalVisible) this.hideModal();else this.showModal();
  }
  async init() {
    if (this.inited) return;
    this.inited = true;
    await this.$nextTick();
    this.$watch(() => {
      const {
        modalVisible
      } = this;
      const cmOptions = this.owner.icmbCmOptions;
      const options = {
        lineNumbers: modalVisible ? true : cmOptions.lineNumbers,
        lineWrapping: modalVisible ? true : cmOptions.lineWrapping
      };
      return options;
    }, xOptions => {
      const cm = this.owner.cm;
      forEach(xOptions, (v, k) => cm.setOption(k, v));
    }, {
      immediate: true
    });
  }
  transformEditor() {
    const placeholderEl = elt('div', {
      class: 'ucd-icmbpe-placeholder'
    }, ['编辑器已单独打开，点击还原']);
    this.placeholderEl = placeholderEl;
    placeholderEl.addEventListener('click', this.toggleModal);
    // 将codemirror和其他的东西一并移动到弹窗中 所以改成用数组来接
    const el = Array.from(this.owner.$el.querySelectorAll('.vue-codemirror-edit'));
    this.vueCodemirrorEls = el;
    if (el !== null && el !== void 0 && el[0]) {
      el[0].parentElement.insertBefore(placeholderEl, el[0]);
      el.forEach(e => {
        this.containerEl.appendChild(e);
      });
    }
  }
  initModelPosition() {
    // eslint-disable-next-line prefer-const
    let {
      left,
      top,
      width: ownerWidth,
      height: ownerHeight
    } = this.owner.$el.getBoundingClientRect();
    if (this.width < ownerWidth) this.width = ownerWidth;
    if (this.height < ownerHeight) this.height = ownerHeight;
    left += ownerWidth;
    if (left + this.width + 40 >= window.innerWidth) left -= ownerWidth + this.width + 20;
    top -= 60;
    top -= Math.max(0, top + this.height - window.innerHeight);
    if (top < 0) top = 0;
    // 覆盖在原输入框的方式
    // left -= Math.max(0, left + this.width + 40 - window.innerWidth);
    // top -= Math.max(0, top + this.height + 60 - window.innerHeight);
    this.left = `${left}px`;
    this.top = `${top}px`;
  }
  onShowModal() {
    this.transformEditor();
  }
  async showModal() {
    var _this$owner$cm$closeH, _this$owner$cm;
    if (this.modalVisible) return;
    await this.init();
    this.initModelPosition();
    this.modalVisible = true;
    await this.$nextTick();
    this.onShowModal();
    await this.$nextTick();
    (_this$owner$cm$closeH = (_this$owner$cm = this.owner.cm).closeHint) === null || _this$owner$cm$closeH === void 0 || _this$owner$cm$closeH.call(_this$owner$cm);
    this.owner.cm.focus();
    // 样式问题
    await delay(200);
    this.owner.cm.refresh();
  }
  /** @abstract */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHideModal() {}
  async hideModal() {
    var _this$owner$cm$closeH2, _this$owner$cm2;
    if (!this.modalVisible) return;
    this.onHideModal();
    if (this.placeholderEl) {
      var _this$vueCodemirrorEl;
      const placeholderEl = this.placeholderEl;
      (_this$vueCodemirrorEl = this.vueCodemirrorEls) === null || _this$vueCodemirrorEl === void 0 || _this$vueCodemirrorEl.forEach(el => {
        placeholderEl.parentElement.insertBefore(el, placeholderEl);
      });
      placeholderEl.remove();
      this.placeholderEl = null;
    }
    this.modalVisible = false;
    await this.$nextTick();
    (_this$owner$cm$closeH2 = (_this$owner$cm2 = this.owner.cm).closeHint) === null || _this$owner$cm$closeH2 === void 0 || _this$owner$cm$closeH2.call(_this$owner$cm2);
    this.owner.cm.focus();
    this.owner.cm.refresh();
  }
  startResizing(ev) {
    const initWidth = this.width;
    const initHeight = this.height;
    const initLeft = parseInt(this.left, 10);
    const initTop = parseInt(this.top, 10);
    const srcEl = ev.target;
    const at = srcEl.getAttribute('at') || '';
    const changeLeft = at.includes('left');
    const changeTop = at.includes('top');
    const changeWidth = at.includes('right') || changeLeft;
    const changeHeight = at.includes('bottom') || changeTop;
    startMouseMove({
      initialEvent: ev,
      onMove: ({
        deltaX,
        deltaY
      }) => {
        if (changeWidth) {
          this.width = Math.max(initWidth + (changeLeft ? -1 : 1) * deltaX, 200);
          if (changeLeft) this.left = `${initLeft - this.width + initWidth}px`;
        }
        if (changeHeight) {
          this.height = Math.max(initHeight + (changeTop ? -1 : 1) * deltaY, 200);
          if (changeTop) this.top = `${initTop - this.height + initHeight}px`;
        }
      }
    });
  }
  handleKeydown(ev) {
    const cancelEscConfirming = () => {
      if (!this.escConfirming) return false;
      clearTimeout(this.escConfirming);
      this.escConfirming = null;
      return true;
    };
    if (ev.code === 'Escape') {
      if (cancelEscConfirming()) {
        ev.preventDefault();
        ev.stopPropagation();
        this.hideModal();
        return;
      }
      this.escConfirming = setTimeout(cancelEscConfirming, 1000);
      return;
    }
    cancelEscConfirming();
  }
  get ucWindowEvents() {
    return {
      close: this.hideModal,
      'update:left': x => this.left = x,
      'update:top': y => this.top = y
    };
  }
  renderContent() {
    const h = this.$createElement;
    return [h("div", {
      "class": "ucd-icmbpe-toolbar"
    }, [this.owner.icmbActualToolbarContent]), h("div", {
      "class": "ucd-icmbpe-container",
      "key": "container",
      "on": {
        "keydown": this.handleKeydown
      },
      "ref": "containerEl",
      "style": `position:relative;height:${this.height}px`
    })];
  }
  render() {
    const h = arguments[0];
    if (!this.inited) return null;
    return h(Portal, {
      "attrs": {
        "target": "window"
      }
    }, [h("uc-window", _mergeJSXProps([{
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": `${this.width}px`,
        "title": this.owner.popupTitle,
        "visible": this.modalVisible
      },
      "on": {
        "close": this.hideModal
      }
    }, {
      "on": this.ucWindowEvents
    }]), [this.renderContent(), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "right"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "left"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "bottom"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "right-bottom"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "left-top"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), h("div", {
      "class": "ucd-icmbpe-resizer",
      "attrs": {
        "at": "left-bottom"
      },
      "on": {
        "mousedown": this.startResizing
      }
    }), !!this.escConfirming && h("div", {
      "class": "ucd-icmbpe-escape-tooltip"
    }, ["\u518D\u6309\u4E00\u6B21 Esc \u5173\u95ED"])])]);
  }
};
__decorate([Prop({})], ICMBPopupEditor.prototype, "owner", void 0);
__decorate([Ref()], ICMBPopupEditor.prototype, "containerEl", void 0);
ICMBPopupEditor = __decorate([Component({
  components: {
    UcWindow
  }
})], ICMBPopupEditor);
export { ICMBPopupEditor };
//# sourceMappingURL=PopupEditor.js.map
